import EventEmitter from 'eventemitter3';
import { InnerEventTypes } from './inner-event';

// SDK 内部通信使用的 event bus
const innerEmitter = new EventEmitter<InnerEventTypes>();

export default innerEmitter;
